import type { ButtonHTMLAttributes } from 'react';

import './tile.css';

export interface TileProps extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  active?: boolean;
  description?: string;
  size?: 'big' | 'small';
  title: string;
}

const FIGMA_NODES = {
  big: { active: '2473:25402', default: '2473:25401' },
  small: { active: '2473:26102', default: '2473:26108' },
} as const;

export function Tile({
  active = false,
  description,
  size = 'big',
  title,
  className = '',
  ...props
}: TileProps) {
  return (
    <button
      {...props}
      aria-pressed={active}
      className={['lovo-tile', `lovo-tile--${size}`, active ? 'lovo-tile--active' : '', className]
        .filter(Boolean)
        .join(' ')}
      data-figma-node={FIGMA_NODES[size][active ? 'active' : 'default']}
      data-figma-variant={`Type=${size === 'big' ? 'Big' : 'Small'}, State=${active ? 'Active' : 'Default'}`}
      type="button"
    >
      <strong>{title}</strong>
      {description && <span>{description}</span>}
    </button>
  );
}
